<div class="formulario">

  <form [formGroup]="formulario">

    <!--NOMBRE-->
    <div class="form-group">
      <label for="nombre">Nombre</label>
      <input type="text" class="form-control" [ngClass]=" {'is-invalid': nombre.invalid && (nombre.touched || nombre.dirty), 'is-valid' :
                nombre.valid}" formControlName="nombre" name="nombre" />
      <div class="invalid-feedback" *ngIf=" nombre.invalid && nombre.errors.required">
        Campo requerido.
      </div>
      <div class="invalid-feedback" *ngIf=" nombre.invalid && nombre.errors.minlength">
        Nombre debera tener mas de 2 letras.
      </div>
      <div class="invalid-feedback" *ngIf=" nombre.invalid && nombre.errors.maxlength">
        Nombre no debera tener mas de 20 letras.
      </div>
    </div>

    <!--CORREO-->
    <div class="form-group">
      <label for="correo">Correo electronico</label>
      <input type="email" class="form-control"
        [ngClass]="{ 'is-invalid': correo.invalid && (correo.touched || correo.dirty ), 'is-valid': correo.valid}"
        formControlName="correo" name="correo" />

      <div class="invalid-feedback" *ngIf=" correo.invalid && correo.errors.required">
        Campo requerido.
      </div>
      <div class="invalid-feedback" *ngIf=" correo.invalid && correo.errors.minlength">
        Correo debera tener mas de 5 letras.
      </div>
      <div class="invalid-feedback" *ngIf="(correo.dirty || correo.touched) && correo.invalid && correo.errors.pattern">
        Debe introducir un correo valido.
      </div>
    </div>

    <!--TELELFONO-->
    <div class="form-row">
      <div class="form-group">
        <label for="telefono">Telefono</label>
        <input type="tel" class="form-control"
          [ngClass]="{ 'is-invalid': telefono.invalid && (telefono.touched || telefono.dirty) , 'is-valid': telefono.valid}"
          formControlName="telefono" name="telefono" />
        <div class="invalid-feedback" *ngIf=" telefono.invalid && telefono.errors.required">
          Campo requerido.
        </div>
        <div class="invalid-feedback"
          *ngIf=" (telefono.dirty || telefono.touched) && telefono.invalid && telefono.errors.pattern">
          Telefono debera (011) 1234-5678
        </div>
      </div>
    </div>

    <!--MENSAJE-->
    <div class="form-group">
      <label for="mensaje">Mensaje</label>
      <textarea class=" form-control"
        [ngClass]="{ 'is-invalid': mensaje.invalid && (mensaje.touched || mensaje.dirty) , 'is-valid': mensaje.valid}"
        formControlName="mensaje" name="direccion" rows="3"></textarea>
      <div class="invalid-feedback" *ngIf=" mensaje.invalid && mensaje.errors.required">
        Campo requerido.
      </div>
      <div class="invalid-feedback" *ngIf=" mensaje.invalid && mensaje.errors.minlength">
        Mensaje debera tener mas de 5 caracteres.
      </div>
      <div class="invalid-feedback" *ngIf=" mensaje.invalid && mensaje.errors.maxlength">
        Mensaje no debera tener mas de 280 caracteres.
      </div>
    </div>

    <div class="boton text-center">
      <button type="submit" (click)="enviarFormulario()" [disabled]="!formulario.valid" class="btn btn-primary">Enviar
        Mensaje</button>
    </div>


  </form>
</div>
